import { gql } from "@apollo/client";

export const GET_PRODUCTS = gql`
  query GetProducts($query: QueryInput, $product: ProductInput) {
    products(query: $query, product: $product) {
      products {
        _id
        name
        make
        model
        category
        external_description
        repairShopr_id
        retail_price
        created_at
        updated_at
        tags
      }
      metaData {
        totalCount
        totalPages
        limit
      }
    }
  }
`;
